<!-- eslint-disable max-len -->
<template>
  <div class="component-card">
    <j-title-header :options="title"/>

    <b-row>
      <b-col md="12">
        <b-form-group :class="{'error-input' : $v.data_master.kode_pegawai.$error}">
          <label> Kode Pegawai </label>
          <j-input
            v-model="$v.data_master.kode_pegawai.$model"
            placeholder="Kode Pegawai"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.password.$error}">
          <label> Password </label>
          <j-input
            v-model="$v.data_master.password.$model"
            :error-required="$v.data_master.password.$error"
            :type="password"
            placeholder="Password"/>
        </b-form-group>
        <b-form-checkbox v-model="show_pass">show password</b-form-checkbox><br><br>

        <b-form-group :class="{'error-input' : $v.data_master.confirm_password.$error || data_master.confirm_password !== data_master.password }">
          <label> Confirm Password </label>
          <j-input
            v-model="$v.data_master.confirm_password.$model"
            :error-required="$v.data_master.confirm_password.$error"
            :type="confirm_password"
            placeholder="Confirm Password"/>
        </b-form-group>
        <b-form-checkbox v-model="show_conpass">show password</b-form-checkbox><br><br>

        <h4>IDENTITAS PENDIDIK DAN TENAGA KEPENDIDIKAN</h4>
        <hr>

        <b-form-group :class="{'error-input' : $v.data_master.nama_pegawai.$error}">
          <label> Nama Pegawai </label>
          <j-input
            v-model="$v.data_master.nama_pegawai.$model"
            placeholder="Nama Pegawai"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.gelar_depan.$error}">
          <label> Gelar Depan </label>
          <j-input
            v-model="$v.data_master.gelar_depan.$model"
            placeholder="Gelar Depan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.gelar_belakang.$error}">
          <label> Gelar Belakang </label>
          <j-input
            v-model="$v.data_master.gelar_belakang.$model"
            placeholder="Gelar Belakang"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nik.$error}">
          <label> NIK </label>
          <j-input
            v-model="$v.data_master.nik.$model"
            placeholder="NIK"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
          <label> Jenis Kelamin </label>
          <b-form-radio-group
            v-model="$v.data_master.jenis_kelamin.$model"
            :options="list_jenis_kelamin"
            :stacked="true"
            :disabled="false"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
          <label> Tempat Lahir </label>
          <j-input
            v-model="$v.data_master.tempat_lahir.$model"
            placeholder="Tempat Lahir"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
          <label> Tanggal Lahir </label>
          <j-datepicker
            v-model="$v.data_master.tanggal_lahir.$model"
            placeholder="Tanggal Lahir"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_ibukandung.$error}">
          <label> Nama Ibu Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ibukandung.$model"
            placeholder="Nama Ibu Kandung"/>
        </b-form-group>

        <h4>DATA PRIBADI</h4>
        <hr>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_rumah.$error}">
          <label> Alamat Rumah </label>
          <j-textarea
            v-model="$v.data_master.alamat_rumah.$model"
            placeholder="Alamat Rumah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rt.$error}">
          <label> RT </label>
          <j-input
            v-model="$v.data_master.rt.$model"
            placeholder="RT"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rw.$error}">
          <label> RW </label>
          <j-input
            v-model="$v.data_master.rw.$model"
            placeholder="RW"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.dusun.$error}">
          <label> Dusun </label>
          <j-input
            v-model="$v.data_master.dusun.$model"
            placeholder="Dusun"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kelurahan_desa.$error}">
          <label> Kelurahan/Desa </label>
          <j-input
            v-model="$v.data_master.kelurahan_desa.$model"
            placeholder="Kelurahan/Desa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kecamatan.$error}">
          <label> Kecamatan </label>
          <j-input
            v-model="$v.data_master.kecamatan.$model"
            placeholder="Kecamatan"/>
        </b-form-group>

        <!-- <b-form-group :class="{'error-input' : $v.data_master.lintang.$error}">
          <label> Lintang </label>
          <j-input
            v-model="$v.data_master.lintang.$model"
            placeholder="Lintang"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.bujur.$error}">
          <label> Bujur </label>
          <j-input
            v-model="$v.data_master.bujur.$model"
            placeholder="Bujur"/>
        </b-form-group> -->

        <b-form-group :class="{'error-input' : $v.data_master.no_kartu_keluarga.$error}">
          <label> No Kartu Keluarga </label>
          <j-input
            v-model="$v.data_master.no_kartu_keluarga.$model"
            placeholder="No Kartu Keluarga"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kode_pos.$error}">
          <label> Kode POS </label>
          <j-input
            v-model="$v.data_master.kode_pos.$model"
            placeholder="Kode POS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.agama.$error}">
          <label> Agama </label>
          <j-single-select
            v-model="$v.data_master.agama.$model"
            :options="list_agama"
            placeholder="Pilih Agama"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.npwp.$error}">
          <label> NPWP </label>
          <j-input
            v-model="$v.data_master.npwp.$model"
            placeholder="NPWP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_wajib_pajak.$error}">
          <label> Nama Wajib Pajak </label>
          <j-input
            v-model="$v.data_master.nama_wajib_pajak.$model"
            placeholder="Nama Wajib Pajak"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kewarganegaraan.$error}">
          <label> Kewarganegaraan </label>
          <b-form-radio-group
            v-model="$v.data_master.kewarganegaraan.$model"
            :options="list_kewarganegaraan"
            :stacked="true"
            :disabled="false"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.status_kawin.$error}">
          <label> Status Perkawinan </label>
          <b-form-radio-group
            v-model="$v.data_master.status_kawin.$model"
            :options="list_status_perkawinan"
            :stacked="true"
            :disabled="false"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_suami_isteri.$error}">
          <label> Nama Suami/Istri </label>
          <j-input
            v-model="$v.data_master.nama_suami_isteri.$model"
            placeholder="Nama Suami/Istri"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nip_suami_isteri.$error}">
          <label> NIP Suami/Istri </label>
          <j-input
            v-model="$v.data_master.nip_suami_isteri.$model"
            placeholder="NIP Suami/Istri"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_suami_isteri.$error}">
          <label> Pekerjaan Suami/Istri </label>
          <j-input
            v-model="$v.data_master.pekerjaan_suami_isteri.$model"
            placeholder="Pekerjaan Suami/Istri"/>
        </b-form-group>

        <h4>KEPEGAWAIAN</h4>
        <hr>

        <b-form-group :class="{'error-input' : $v.data_master.status_kepegawaian.$error}">
          <label> Status Status Kepegawaian </label>
          <j-input
            v-model="$v.data_master.status_kepegawaian.$model"
            placeholder="Status Status Kepegawaian"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nip.$error}">
          <label> NIP </label>
          <j-input
            v-model="$v.data_master.nip.$model"
            placeholder="NIP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.niy_nigk.$error}">
          <label> NIY/NIGK </label>
          <j-input
            v-model="$v.data_master.niy_nigk.$model"
            placeholder="NIY/NIGK"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nuptk.$error}">
          <label> NUPTK </label>
          <j-input
            v-model="$v.data_master.nuptk.$model"
            placeholder="BUPTK"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.jenis_ptk.$error}">
          <label> Jenis PTK </label>
          <j-input
            v-model="$v.data_master.jenis_ptk.$model"
            placeholder="Jenis PTK"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.sk_pengangkatan.$error}">
          <label> SK Pengangkatan </label>
          <j-input
            v-model="$v.data_master.sk_pengangkatan.$model"
            placeholder="SK Pengangkatan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tmt_pengangkatan.$error}">
          <label> TMT Pengangkatan </label>
          <j-datepicker
            v-model="$v.data_master.tmt_pengangkatan.$model"
            placeholder="TMT Pengangkatan"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.lembaga_pengangkat.$error}">
          <label> Lembaga Pengangkatan </label>
          <j-input
            v-model="$v.data_master.lembaga_pengangkat.$model"
            placeholder="Lembaga Pengangkatan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.sk_cpns.$error}">
          <label> SK CPNS </label>
          <j-input
            v-model="$v.data_master.sk_cpns.$model"
            placeholder="SK CPNS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tmt_pns.$error}">
          <label> TMT PNS </label>
          <j-datepicker
            v-model="$v.data_master.tmt_pns.$model"
            placeholder="TMT PNS"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pangkat_gol.$error}">
          <label> Pangkat/Golongan </label>
          <j-input
            v-model="$v.data_master.pangkat_gol.$model"
            placeholder="Pangkat/Golongan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.sumber_gaji.$error}">
          <label> Sumber Gaji </label>
          <j-input
            v-model="$v.data_master.sumber_gaji.$model"
            placeholder="Sumber Gaji"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kartu_pegawai.$error}">
          <label> Kartu Pegawai </label>
          <j-input
            v-model="$v.data_master.kartu_pegawai.$model"
            placeholder="Kartu Pegawai"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kartu_suami_isteri.$error}">
          <label> Kartu Istri/Kartu Suami </label>
          <j-input
            v-model="$v.data_master.kartu_suami_isteri.$model"
            placeholder="Kartu Istri/Kartu Suami"/>
        </b-form-group>

        <h4>KOMPETENSI KHUSUS</h4>
        <hr>

        <b-form-group :class="{'error-input' : $v.data_master.lisensi_kepsek.$error}">
          <label> Punya Lisensi Kepala Sekolah </label>
          <j-input
            v-model="$v.data_master.lisensi_kepsek.$model"
            placeholder="Punya Lisensi Kepala Sekolah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_registrasi.$error}">
          <label> No Registrasi </label>
          <j-input
            v-model="$v.data_master.no_registrasi.$model"
            placeholder="No Registrasi"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.keahlian_laboratorium.$error}">
          <label> Keahlian Laboratorium </label>
          <j-input
            v-model="$v.data_master.keahlian_laboratorium.$model"
            placeholder="Keahlian Laboratorium"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.mampu_menangani_kebutuhan_khusus.$error}">
          <label> Mampu Menangani Kebutuhan Khusus </label>
          <j-input
            v-model="$v.data_master.mampu_menangani_kebutuhan_khusus.$model"
            placeholder="Mampu Menangani Kebutuhan Khusus"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.keahlian_braile.$error}">
          <label> Keahlian Braile </label>
          <b-form-radio-group
            v-model="$v.data_master.keahlian_braile.$model"
            :options="list_yes_no"
            :stacked="true"
            :disabled="false"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.keahlian_bahasa_isyarat.$error}">
          <label> Keahlian Bahasa Isyarat </label>
          <b-form-radio-group
            v-model="$v.data_master.keahlian_bahasa_isyarat.$model"
            :options="list_yes_no"
            :stacked="true"
            :disabled="false"
            class="jFormGroup"/>
        </b-form-group>

        <h4>KONTAK</h4>
        <hr>

        <b-form-group :class="{'error-input' : $v.data_master.telp_rumah.$error}">
          <label> No Telepon Rumah </label>
          <j-input
            v-model="$v.data_master.telp_rumah.$model"
            placeholder="No Telepon Rumah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.hp.$error}">
          <label> No HP </label>
          <j-input
            v-model="$v.data_master.hp.$model"
            placeholder="No HP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.email.$error}">
          <label> Email </label>
          <j-input
            v-model="$v.data_master.email.$model"
            placeholder="Email"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="float-to-right m__t--20">
          <b-button
            class="btn blue m__r--5"
            @click="saveData">
            Save
          </b-button>
          <b-button
            class="btn gray"
            @click="$router.replace('/kepegawaian')">
            Cancel
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  components: {
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Create Data Pegawai',
      },

      data_master: {
        kode_pegawai: '',
        password: '',
        confirm_password: '',

        nama_pegawai: '',
        gelar_depan: '',
        gelar_belakang: '',
        nik: '',
        jenis_kelamin: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        nama_ibukandung: '',

        alamat_rumah: '',
        rt: '',
        rw: '',
        dusun: '',
        kelurahan_desa: '',
        kecamatan: '',
        // lintang: '',
        // bujur: '',
        no_kartu_keluarga: '',
        kode_pos: '',
        agama: null,
        npwp: '',
        nama_wajib_pajak: '',
        kewarganegaraan: null,
        status_kawin: null,
        nama_suami_isteri: '',
        nip_suami_isteri: '',
        pekerjaan_suami_isteri: '',

        status_kepegawaian: '',
        nip: '',
        niy_nigk: '',
        nuptk: '',
        jenis_ptk: '',
        sk_pengangkatan: '',
        tmt_pengangkatan: null,
        lembaga_pengangkat: '',
        sk_cpns: '',
        tmt_pns: null,
        pangkat_gol: '',
        sumber_gaji: '',
        kartu_pegawai: '',
        kartu_suami_isteri: '',

        lisensi_kepsek: '',
        no_registrasi: '',
        keahlian_laboratorium: '',
        mampu_menangani_kebutuhan_khusus: '',
        keahlian_braile: null,
        keahlian_bahasa_isyarat: null,

        telp_rumah: '',
        hp: '',
        email: '',
      },
      show_pass: false,
      show_conpass: false,
      list_jenis_kelamin: [
        {
          value: 'Laki-Laki',
          text: 'Laki-Laki',
        },
        {
          value: 'Perempuan',
          text: 'Perempuan',
        },
      ],
      list_agama: [
        {
          id: 'Islam',
          name: 'Islam',
        },
        {
          id: 'Kristen/Protestan',
          name: 'Kristen/Protestan',
        },
        {
          id: 'Hindu',
          name: 'Hindu',
        },
        {
          id: 'Budha',
          name: 'Budha',
        },
        {
          id: 'Kong Hu Chu',
          name: 'Kong Hu Chu',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
      list_kewarganegaraan: [
        {
          value: 'Indonesia',
          text: 'Indonesia (WNI)',
        },
        {
          value: 'Asing',
          text: 'Asing (WNA)',
        },
      ],
      list_status_perkawinan: [
        {
          value: 'Kawin',
          text: 'Kawin',
        },
        {
          value: 'Belum Kawin',
          text: 'Belum Kawin',
        },
        {
          value: 'Janda/Duda',
          text: 'Janda/Duda',
        },
      ],
      list_yes_no: [
        {
          value: 'Ya',
          text: 'Ya',
        },
        {
          value: 'Tidak',
          text: 'Tidak',
        },
      ],
    };
  },
  computed: {
    password() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },

    confirm_password() {
      if (this.show_conpass) {
        return 'text';
      }
      return 'password';
    },
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreKurikulum', ['createPegawai']),

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createPegawai(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$router.push('/kepegawaian');
            }, 1500);
          }
        });
      }
    },
  },
  validations() {
    return {
      data_master: {
        kode_pegawai: { required },
        password: { required },
        confirm_password: { required },

        nama_pegawai: { required },
        gelar_depan: {},
        gelar_belakang: {},
        nik: { required },
        jenis_kelamin: {},
        tempat_lahir: {},
        tanggal_lahir: {},
        nama_ibukandung: {},

        alamat_rumah: {},
        rt: {},
        rw: {},
        dusun: {},
        kelurahan_desa: {},
        kecamatan: {},
        // lintang: {},
        // bujur: {},
        no_kartu_keluarga: {},
        kode_pos: {},
        agama: {},
        npwp: {},
        nama_wajib_pajak: {},
        kewarganegaraan: {},
        status_kawin: {},
        nama_suami_isteri: {},
        nip_suami_isteri: {},
        pekerjaan_suami_isteri: {},
        status_kepegawaian: {},
        nip: {},
        niy_nigk: {},
        nuptk: {},
        jenis_ptk: {},
        sk_pengangkatan: {},
        tmt_pengangkatan: {},
        lembaga_pengangkat: {},
        sk_cpns: {},
        tmt_pns: {},
        pangkat_gol: {},
        sumber_gaji: {},
        kartu_pegawai: {},
        kartu_suami_isteri: {},

        lisensi_kepsek: {},
        no_registrasi: {},
        keahlian_laboratorium: {},
        mampu_menangani_kebutuhan_khusus: {},
        keahlian_braile: {},
        keahlian_bahasa_isyarat: {},

        telp_rumah: {},
        hp: {},
        email: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/jKepegawaianCreate.vue